import { isDefined } from "@clipboard-health/util-ts";
import { InfoBanner } from "@src/appV2/redesign/components/InfoBanner/InfoBanner";
import { formatCentsAsUsd } from "@src/appV2/lib/Money/utils/currency";

interface SpendLimitWarningProps {
  overageInMinorUnits: number;
  limitInMinorUnits: number | undefined;
}

/**
 * Non-blocking variable-charge cap warning for CBH admins. Unlike the workplace-facing
 * `RateBoostLimitCard`, it has no "request an increase from your account manager" action —
 * admins aren't the workplace and are never blocked, they're only warned. Shared by the
 * admin edit-shift confirmation modal and the schedule charge dialog.
 */
export function SpendLimitWarning({
  overageInMinorUnits,
  limitInMinorUnits,
}: SpendLimitWarningProps) {
  const overage = formatCentsAsUsd(overageInMinorUnits);
  const limitClause = isDefined(limitInMinorUnits)
    ? ` of ${formatCentsAsUsd(limitInMinorUnits)}`
    : "";

  return (
    <InfoBanner
      variant="warning"
      title="Boost would exceed spend control limit"
      message={`This charge would put the workplace about ${overage} over its weekly rate boost limit${limitClause}. You can still proceed.`}
      sx={{ marginTop: 4 }}
    />
  );
}
